import IAcademicIdentificationDocumentFull from "./IAcademicIdentificationDocumentFull";
import AcademicCardType from "@/module/main/dto/customer/AcademicCardTypeEnum";

export default class AcademicIdentificationDocumentFull implements IAcademicIdentificationDocumentFull
{
    constructor(
        public number?: string,
        public validity?: string,
        public firstName?: string,
        public lastName?: string,
        public type?: AcademicCardType,
    )
    {
    }
}
